import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule }   from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AngularFireAuthModule } from '@angular/fire/auth';
import {
  NbAlertModule,
  NbInputModule,
  NbCheckboxModule,
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbTabsetModule,
  NbUserModule,
  NbRadioModule,
  NbSelectModule,
  NbListModule,
  NbIconModule,
} from '@nebular/theme';
import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { RestorePasswordComponent } from './restore-password/restore-password.component';

@NgModule({
  declarations: [LoginComponent, SignUpComponent, RestorePasswordComponent],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    AngularFireAuthModule,
    NbAlertModule,
    NbInputModule,
    NbActionsModule,
    NbCheckboxModule,
    NbButtonModule,
    NbCardModule,
    NbTabsetModule,
    NbUserModule,
    NbRadioModule,
    NbSelectModule,
    NbListModule,
    NbIconModule,
  ]
})
export class AuthModule { }
